import Vue from 'vue'

const requireComponent = require.context(
  '.',
  false,
  /(Layout|Base)[\w-]+\.vue$/
)

requireComponent.keys().forEach(filaName => {
  const componentConfig = requireComponent(filaName)
  const componentName = filaName
    // Remove the "./" from the beginning
    .replace(/^\.\//, '')
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})
